import type { GetPlanOverviewResponse } from '@weft/api-definition';
import { GetPlanOverviewResponseSchema } from '@weft/api-definition';
import { validateNotEmptyObject } from '@weft/utils';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';
import type { CustomBaseUseQueryOptions } from './requests-types/custom-use-query-options';

export function usePlanOverviewOptions(planId: string, api = getPrivateApi()): CustomBaseUseQueryOptions<GetPlanOverviewResponse> {
  return {
    queryKey: ['plan-overview', planId],
    suspense: true,
    queryFn: async () => {
      const getPlanOverviewResponse = await api.getPlanOverview({ planId });

      return GetPlanOverviewResponseSchema.parse(getPlanOverviewResponse);
    },
  };
}

export function usePlanOverview(planId: string, options?: CustomUseQueryOptions<GetPlanOverviewResponse>) {
  const planOverviewQuery = useQuery(['plan-overview', planId], async () => {
    const privateApi = getPrivateApi();
    const getPlanOverviewResponse = await privateApi.getPlanOverview({ planId });

    return GetPlanOverviewResponseSchema.parse(getPlanOverviewResponse);
  }, { suspense: true, ...options });
  validateNotEmptyObject(planOverviewQuery.data, 'planOverviewQuery.data');

  return planOverviewQuery;
}